
export default function Footer() {
  const footerLinks = {
    product: [
      { name: 'Features', href: '#essential-tools' },
      { name: 'How It Works', href: '#' },
      { name: 'Testimonials', href: '#' }
    ],
    company: [
      { name: 'About Us', href: '#' },
      { name: 'Careers', href: '#' },
      { name: 'Blog', href: '#' },
      { name: 'Press', href: '#' }
    ],
    support: [
      { name: 'Help Center', href: '#' },
      { name: 'Contact Us', href: '#' },
      { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: '#' }
    ]
  };

  return (
    <footer className="bg-white border-t border-[#ABB2B9]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12 lg:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-8 sm:gap-10 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#35C5F0] rounded-lg flex items-center justify-center">
                <i className="ri-home-smile-line text-white text-lg sm:text-xl"></i>
              </div>
              <span className="text-lg sm:text-xl font-bold text-[#2F3438]">Wowhouse</span>
            </div>
            <p className="text-sm sm:text-base text-[#ABB2B9] mb-4 sm:mb-6 leading-relaxed max-w-sm">
              The professional portfolio platform for interior designers, architects, and renovation companies. One link. Infinite possibilities.
            </p>
            <div className="flex items-center gap-3 sm:gap-4">
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#F8F9FA] rounded-lg text-[#ABB2B9] hover:text-[#35C5F0] hover:bg-[#35C5F0]/10 transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-base sm:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#F8F9FA] rounded-lg text-[#ABB2B9] hover:text-[#35C5F0] hover:bg-[#35C5F0]/10 transition-all cursor-pointer">
                <i className="ri-linkedin-line text-base sm:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#F8F9FA] rounded-lg text-[#ABB2B9] hover:text-[#35C5F0] hover:bg-[#35C5F0]/10 transition-all cursor-pointer">
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#F8F9FA] rounded-lg text-[#ABB2B9] hover:text-[#35C5F0] hover:bg-[#35C5F0]/10 transition-all cursor-pointer">
                <i className="ri-youtube-line text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold text-[#2F3438] mb-3 sm:mb-4 text-sm sm:text-base">Product</h4>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm sm:text-base text-[#ABB2B9] hover:text-[#35C5F0] transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-[#2F3438] mb-3 sm:mb-4 text-sm sm:text-base">Company</h4>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm sm:text-base text-[#ABB2B9] hover:text-[#35C5F0] transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div className="col-span-2 sm:col-span-1">
            <h4 className="font-semibold text-[#2F3438] mb-3 sm:mb-4 text-sm sm:text-base">Support</h4>
            <ul className="space-y-2 sm:space-y-3">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm sm:text-base text-[#ABB2B9] hover:text-[#35C5F0] transition-colors cursor-pointer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 sm:mt-12 lg:mt-16 pt-6 sm:pt-8 border-t border-[#ABB2B9]/20 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm text-[#ABB2B9] text-center sm:text-left">
            © 2024 Wowhouse. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-[#ABB2B9] hover:text-[#35C5F0] transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
